import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiService} from "@core/shared/services/api.service";
import {OfferLocation} from "@core/shared/models/offer/offer-location";
import {Pagination} from "@core/shared/models/pagination";
import {map} from "rxjs/operators";
import {plainToClass} from "class-transformer";
import {AllPaginateItemsAPI, DEFAULT_ALL_PAGINATE_ITEMS_API_LIMIT} from "@core/shared/models/all-paginate-items-api";
import {AdditionalHeader} from "@core/shared/models/http-client";
import {DEACTIVATE_LOADER_HEADER_IDENTIFIER} from "@app/data";

@Injectable({
    providedIn: 'root'
})
export class OfferLocationService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {}

    public getItemsAPI(params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<OfferLocation[]> {

        return new AllPaginateItemsAPI<OfferLocation>(this.getPaginationItemsAPI.bind(this), params, DEFAULT_ALL_PAGINATE_ITEMS_API_LIMIT, additionalHeaders).request$;
    }

    public getPaginationItemsAPI(params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<Pagination<OfferLocation>> {

        let headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        additionalHeaders?.forEach(header => headers = headers.append(header.name, header.value.toString()));

        let url: string = `${this._apiService.getApiUrl(false, true)}/offers/locations`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<OfferLocation>>(url, {headers: headers})
            .pipe(
                map((pagination: Pagination<OfferLocation>): Pagination<OfferLocation> => {

                    return Object.assign(pagination, {
                        items: pagination.items.map((item: OfferLocation): OfferLocation => {

                            return plainToClass(OfferLocation, item);
                        })
                    });
                })
            );
    }

    public getOfferItemsAPI(offerId: number, params?: string[]): Observable<OfferLocation[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set(DEACTIVATE_LOADER_HEADER_IDENTIFIER, '1')

        let url: string = `${this._apiService.getApiUrl(false, true)}/offers/${offerId}/locations`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<OfferLocation[]>(url, {headers: headers})
            .pipe(
                map((items: object[]): OfferLocation[] => {

                    return items.map((item: object): OfferLocation => {

                        return plainToClass(OfferLocation, item);
                    })
                })
            );

    }

    public getItemsSocietyAPI(societyId: number, params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<OfferLocation[]> {

        return new AllPaginateItemsAPI<OfferLocation>(this.getPaginationItemsSocietyAPI.bind(this, societyId), params, DEFAULT_ALL_PAGINATE_ITEMS_API_LIMIT, additionalHeaders).request$;
    }

    public getPaginationItemsSocietyAPI(societyId: number, params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<Pagination<OfferLocation>> {

        let headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        additionalHeaders?.forEach(header => headers = headers.append(header.name, header.value.toString()));

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${societyId}/offers/locations`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<OfferLocation>>(url, {
            headers: headers
        }).pipe(
            map((pagination: Pagination<OfferLocation>): Pagination<OfferLocation> => {

                return Object.assign(pagination, {
                    items: pagination.items.map((item: OfferLocation): OfferLocation => {

                        return plainToClass(OfferLocation, item);
                    })
                });
            })
        );
    }

    public getItemsCatalogAPI(params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<OfferLocation[]> {

        return new AllPaginateItemsAPI<OfferLocation>(this.getPaginationItemsCatalogAPI.bind(this), params, DEFAULT_ALL_PAGINATE_ITEMS_API_LIMIT, additionalHeaders).request$;
    }

    public getPaginationItemsCatalogAPI(params?: string[], additionalHeaders?: AdditionalHeader[]): Observable<Pagination<OfferLocation>> {

        let headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        additionalHeaders?.forEach(header => headers = headers.append(header.name, header.value.toString()));

        let url: string = `${this._apiService.getApiUrl(false, true)}/offers/locations/catalog`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<OfferLocation>>(url, {
            headers: headers
        }).pipe(
            map((pagination: Pagination<OfferLocation>): Pagination<OfferLocation> => {

                return Object.assign(pagination, {
                    items: pagination.items.map((item: OfferLocation): OfferLocation => {

                        return plainToClass(OfferLocation, item);
                    })
                });
            })
        );
    }
}
